interface RouteStructure {
  route: string;
  scopes?: string[];
}

const confScope = 'confederacion.read';
const fedScope = 'federacion.read';
const clubScope = 'gestionClub.read';
const torneoScope = 'torneo.read';
const arbitroScope = 'arbitro.read';
const puntosPartidoScope = 'puntosPartido.read';
const tribunalPenaScope = 'tribunalPenas.read';
const tablasComplementariasScope = 'tablasComplementarias.read';
const planillaPartidoScope = 'planillaPartido.read';

export const routes: { [index: string]: RouteStructure } = {
  planilla_partido_programado: { route: '/planilla-partido-programado', scopes: [planillaPartidoScope] },
  planilla_partido_offline: { route: '/planilla-partido-offline', scopes: [planillaPartidoScope] },
  planilla_partido: { route: '/planilla-partido', scopes: [planillaPartidoScope] },
};

export const includesThisRoute = (routesAvailables: string[], pathname: string) => {
  routesAvailables.forEach((route) => {
    if (route[0] === '/') {
      let str = route.slice();
      if (pathname === str) {
        return true;
      }
    }
  });
  return false;
};

/**
 * @returns Si la ruta actual es /planilla_partido_offline o /planilla_partido o / no redirige, en caso de que la ruta necesite estar validada, redirige
 */
export const shouldRedirect = () => {
  let rutaActual = window.location.pathname;
  let partesRuta = rutaActual.split('/');
  let primerPathParam = '/' + partesRuta[1];
  const isFormOffline = primerPathParam === routes.planilla_partido_offline.route;
  const isPlanilla = primerPathParam === routes.planilla_partido.route;
  const isHome = primerPathParam === '/';
  return !isFormOffline && !isPlanilla && !isHome;
};

export const routesAvailableForStandardUser = [];
export const routesAvailableForPowerUser = [...routesAvailableForStandardUser];
